export const MsspProgramMemberActionEnum = {
  AUTO_ASSIGN_SUBMISSION: "PROGRAM_MEMBER_ACTION_ENUM_AUTO_ASSIGN_SUBMISSION",
  DELETE_MEMBER: "PROGRAM_MEMBER_ACTION_ENUM_DELETE_MEMBER",
};
